/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupDto } from '../../models/popup-dto';
import { PopupReorderDto } from '../../models/popup-reorder-dto';

export interface PopupAdminControllerReorderV1$Params {
      body: PopupReorderDto
}

export function popupAdminControllerReorderV1(http: HttpClient, rootUrl: string, params: PopupAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
  const rb = new RequestBuilder(rootUrl, popupAdminControllerReorderV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PopupDto>>;
    })
  );
}

popupAdminControllerReorderV1.PATH = '/api/v1/popups/admin/reorder';
